const locale = {
  LOADER_TEXT: 'Loading',
};

export default locale;
